export default {
    rmcProduceFarmId: [
        { required: true, message: '请选择Farm', trigger: 'change' }
    ],
    reportDate: [
        { required: true, message: '请选择报告期限', trigger: 'change' }
    ],
    cultiVarName: [
        { required: true, message: '请选择作物', trigger: 'change' }
    ],
    plantUnit: [
        { required: true, message: '请输入种植亩数', trigger: 'blur' }
    ],
    yield: [
        { required: true, message: '请输入亩产量', trigger: 'blur' }
    ],
    // netRate: [
    //     { required: true, message: '请输入净含量(%)', trigger: 'blur' }
    // ],
    netRate: [
        {
            validator: (rule, value, callback) => {
                if (value === '') {
                  callback(new Error('请输入净含量(%)'));
                } else {
                  var reg=/^0(0+)|[^\d\.]+/
                  if (reg.test(value)) {
                    callback(new Error('请输入数值'));
                  }
                  callback();
                }
              }, trigger: 'blur'
        }
    ],
    usage: [
        { required: true, message: '请输入使用量(kg)', trigger: 'blur' }
    ],
    netUsage: [
        { required: true, message: '请计算换算原粉量(kg)', trigger: 'blur' }
    ],
    usageNumber: [
        { required: true, message: '请输入使用次数', trigger: 'blur' }
    ],
}